import React, { useContext, useEffect } from "react"
import ReactDOM from 'react-dom'
import TextField from '@material-ui/core/TextField'
import FormControl  from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import Cleave from 'cleave.js/react'

import RenderError from '../render-error'

import MembershipFormContext from '../../context/membership'
import { getSS, setSS, deleteSS } from '../../helpers'

interface MembershipTypeProps {
  [key: string]: any
}

const MembershipType: React.FC<MembershipTypeProps> = (props:any) => {

  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const types = JSON.parse(membership_form.membership_types)
  const paymentType = props.paymentType
  const type = props.type

  useEffect(() => {
    if (type && paymentType) {
      setSelectedMembership(type, paymentType)
      membershipForm.setPreSelected({type: type, payment_type: paymentType})
    }
    if (!type && !paymentType) {
      let membership = getSS('membership')
      if (membership) {
        setSelectedMembership(membership.selected_membership.value, '')
      } else {
        setSelectedMembership('indfriend', '')
      }
    }
    if (type && !paymentType) {
      setSelectedMembership(type, '')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function setSelectedMembership(type: any, paymentType: any) {
    props.setFieldValue('selected_membership_control', type)
    for (let i = 0; i < types.length; i++) {
      if (types[i].value === type) {
        if (getSS('membership')) {
          let membership = getSS('membership')
          membership.selected_membership = types[i]
          if (paymentType !== '') {
            membership.payment_type = paymentType[0].toUpperCase() + paymentType.slice(1);
            deleteSS('payment')
          }
          setSS('membership', membership)
        }
        props.setFieldValue('selected_membership', types[i])
      }
      if (types[i].value !== 'youngpersons' && types[i].value !== 'youngpersonsplus') {
        props.setFieldValue('dob', '')
      }
    }
  }

  const CleaveInput = (props: any) => {
    const { inputRef, ...rest } = props;
    return (
      <Cleave
        {...rest}
        htmlRef={(ref) => inputRef(ReactDOM.findDOMNode(ref))}
        placeholder="dd/mm/yyyy"
        options={{
          date: true,
          datePattern: ['d', 'm', 'Y'],
          blocks: [2,2,4]
        }}
      />
    );
  }

  const selected_membership_control =
    getSS('membership')?.selected_membership?.value ? getSS('membership')?.selected_membership?.value :
    props.values.selected_membership_control ? props.values.selected_membership_control :
    type !== null ? type :
    'indfriend'

  return (
    <>
      <div className="row">
        <div className="membership-type clearfix box">
          <div className="medium-6 columns">
            <h2>Your membership</h2>
            { membershipForm.preSelectedMembership &&
              <p>You’ve chosen the following type of annual membership:</p>
            }
            { !membershipForm.preSelectedMembership &&
              <p>Pick your membership package below – there’s something to suit everyone.</p>
            }
            <div className="input-container select">
              <FormControl>
                <InputLabel htmlFor="title">Membership type</InputLabel>
                <Select
                  variant="outlined"
                  name="selected_membership_control"
                  id="membership-type-choice"
                  inputProps={{
                    "aria-describedby": "membership-type-choice_error"
                  }}
                  error={props.errors.selected_membership_control ? true : false}
                  value={selected_membership_control}
                  onChange={(e) => setSelectedMembership(e.target.value, '')}>
                  {
                    types.map((type:any, index:any) => {
                      return (
                        <MenuItem key={index} value={type.value}>{type.title}</MenuItem>
                      )
                    })
                  }
                </Select>
              </FormControl>
              <RenderError name="selected_membership_control" id="membership-type-choice_error" {...props} />
            </div>
            <p>{props.values.selected_membership.description}</p>
            { (props.values.selected_membership.value === 'youngpersons' || props.values.selected_membership.value === 'youngpersonsplus') &&
              <>
                <p>Please verify that you are eligible for this membership by entering your date of birth here.</p>
                <div className="input-container">
                  <TextField
                    type="tel"
                    variant="outlined"
                    id="dob"
                    name="dob"
                    label="Date of birth"
                    inputProps={{
                      "aria-describedby": "dob_error"
                    }}
                    error={props.errors.dob}
                    value={props.values.dob}
                    onChange={props.handleChange}
                    autoFocus
                    InputProps={{
                      inputComponent: CleaveInput
                    }} />
                  <RenderError name="dob" id="dob_error" {...props} />
                </div>
                { props.values.selected_membership.young_persons_message &&
                  <div dangerouslySetInnerHTML={{ __html: props.values.selected_membership.young_persons_message }}></div>
                }
              </>
            }
          </div>
          <div className="medium-6 columns">
            <img src={props.values.selected_membership.image} alt={props.values.selected_membership.alt} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MembershipType;